import { Component } from "@angular/core";
import { quoteFilterTabsParams, quoteFilterTabsParamsOanda, quoteFilterTabsList } from "./quoteFilterTabs.list";
import { WorkspaceServiceService } from "../../services/workspace-service.service";
import { SymbolTypeEnum } from '../../enums/SymbolType.enum';
import { GlobalGridModeService } from "../../services/globalGridMode/globalGridMode.service";
import { getSymbolOrder, symbolsForexOrder } from "../../services/data/data.service";
import {Providers} from "../../enums/providers";

@Component({
    selector: "quotefilter-tabs",
    template: require('./quoteFilterTabs.component.html'),
    styles: [require('./quoteFilterTabs.component.css')]
})
export class quoteFilterTabs {



    private _tabs: object = quoteFilterTabsParams();
    public get tabs(): object {
        return this._tabs;
    }
    public set tabs(value: object) {
        this._tabs = value;
    }

    constructor(
        private workspaceService: WorkspaceServiceService,        
        private globalGridMode: GlobalGridModeService,
    ) {
    }

    public afterInit:boolean = false;


    get activeTab(): SymbolTypeEnum {

        if((this.workspaceService.data.currentProvider==Providers.OANDA || this.workspaceService.data.currentProvider==Providers.GAIN) && !this.afterInit)
        {
            this.tabs = quoteFilterTabsParamsOanda();
            this.afterInit = true;
            this.activeTab = SymbolTypeEnum.Forex
            
        }

        if(this.workspaceService.data.currentProvider=="DEMO" && this.afterInit)
        {
            this.tabs = quoteFilterTabsParams();
            this.afterInit = false;
            
        }

        return this.workspaceService.data.activeSymbolType;
    }

    set activeTab(tabId: SymbolTypeEnum) {

    

        if(this.workspaceService.data.activeSymbolType == tabId)
            return;

        
        this.workspaceService.data.activeSymbolType = tabId;

        let lg = 0;
        let selectedBasketItems:string[] =[];
        if(this.workspaceService.data.activeBasket!=-1)
        {
             selectedBasketItems =  this.workspaceService.data.getItemsFromBasket(this.workspaceService.data.activeBasket).items;

            console.log(selectedBasketItems);
            lg = selectedBasketItems.length
        }
     

        if(lg==0 && this.workspaceService.data.activeBasket==-1)
        {
            const firstBox = this.workspaceService.data.boxes.find(b => b.searchVisible && b.visible);
            if(firstBox != null)
            this.globalGridMode.emitSymbolChanged({ symbol: firstBox.Symbol, overrideLockAllCharts: false });

        }

        if(lg==0 && this.workspaceService.data.activeBasket!=-1)
        {
            console.log("canChange");
            console.log(this.visibleBoxes);
            // const firstBox = this.workspaceService.data.boxes.find(b => b.searchVisible && b.visible);
            // if(firstBox != null)
            this.globalGridMode.emitSymbolChanged({ symbol: this.visibleBoxes[0].Symbol, overrideLockAllCharts: false });

        }

        // if(lg>0)
        // {
        //     console.log("canChange");
        //     console.log(this.visibleBoxes);
        //     // const firstBox = this.workspaceService.data.boxes.find(b => b.searchVisible && b.visible);
        //     // if(firstBox != null)
        //     this.globalGridMode.emitSymbolChanged({ symbol: selectedBasketItems[0], overrideLockAllCharts: false });

        // }
      


    }
 
    public get visibleBoxes() {
        let standardVisible = this.workspaceService.data.boxes.filter(b => b.visible && b.searchVisible);        
        let type = this.workspaceService.data.activeSymbolType;
        if (standardVisible.length < 6) {
            let notInStandardVisible = this.workspaceService.data.boxes
                .filter(item=> standardVisible.indexOf(item) === -1 && item.Type == type && item.visible)
                .slice(0, 6 - standardVisible.length);
            let merge = standardVisible.concat(notInStandardVisible);
            return merge; //.sort((a, b) => this.getSymbolOrder(a.Symbol)-this.getSymbolOrder(b.Symbol));//.slice(0, this.boxesLimit);
        } else {
            return standardVisible
                .sort((a, b) => this.getSymbolOrder(a.Symbol) - this.getSymbolOrder(b.Symbol))
                .slice(0, 6);
        }
    }

    private _symbolsOrder: string[] = symbolsForexOrder;
    private getSymbolOrder(symbol: string) {
        return getSymbolOrder(symbol, this._symbolsOrder);
    }

}
